import TranslationDropdown from 'components/language-menu/TranslationDropdown';

import { useToggle } from '../../../../hooks/useToggle';
import ProfileMenu from './profile-menu/ProfileMenu';
import { useClickOutside } from 'hooks/useClickOutside';
import { useResponsiveRender } from 'hooks/useResponsiveRender';
import { useOnChangeLocation } from 'hooks/useOnChangeLocations';
import { Menu32 } from '@carbon/icons-react';

// styles
import styles from './language_profile.module.scss';

const LanguageProfile = ({ routesProfileMenu, openSettings, openResetPassword, fullname }) => {
  const { renderMobile } = useResponsiveRender({ breakpoint: 767 });
  const [showProfileMenu, onToggleProfileMenu, onCloseMenu] = useToggle(false);

  const domRef = useClickOutside(() => {
    if (showProfileMenu) onToggleProfileMenu();
  });

  useOnChangeLocation(() => onCloseMenu());

  return (
    <div className={styles.languageProfile}>
      <TranslationDropdown />
      {!renderMobile && (
        <div className="cursor-pointer" onClick={onToggleProfileMenu} ref={domRef} data-testid="navMenu">
          <Menu32 />
        </div>
      )}
      {showProfileMenu && (
        <ProfileMenu
          ref={domRef}
          routesProfileMenu={routesProfileMenu}
          openSettings={openSettings}
          openResetPassword={openResetPassword}
          fullname={fullname}
        />
      )}
    </div>
  );
};

export default LanguageProfile;
